<div *transloco="let t;" class="row flex gap-5 pt-26 h-full onboarding"
  style="background-image: url('./assets/img/BG/BG-Onboarding.jpg');">
  <div class="col-lg-6 w-full md:w-1/2 col chat-container chat-container-column">
    <!-- <div class="chat-container chat-container-column"> -->
    <div class="chat-box flex-row first-block">
      <img src="./assets/img/Prof-light.png" class="prof" />
      <div class="chat-box-text">
        <h1 class="title-gradient gradient-pp uppercase">{{t('onboarding.getStarterItems')}}</h1>
        <p>{{t('onboarding.krypDescriptionLootboxMsg')}}</p>
      </div>
    </div>
    <div class="chat-box second-block">
      <div class="checkout-list">
        <!--<h1 class="checkout-title title-gradient gradient-pp">Cart:</h1>-->
        <div class="checkout-item kryptomon">
          <img src="{{foundKryptomon.nft.image}}" />
          <div class="checkout-item-text">
            <h1> <fa-icon [icon]="['fas', 'snowflake']" *ngIf="foundKryptomon.nft.isFreezed==1"></fa-icon> ID:
              {{foundKryptomon.nft.tokenId}}</h1>
            <p>{{t('shared.tier')}}: {{foundKryptomon.nft.stats.tier}}</p>
          </div>
          <div class="checkout-price">
            <p>${{foundKryptomon.order.priceUSD}}</p>
            <div class="divider"></div>
            <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{foundKryptomon.order.priceKMON}}</p>
          </div>
        </div>
        <div class="checkout-item lootbox" *ngIf="selectedBox!==undefined">
          <img src="{{selectedBox.img}}" class="lb" />
          <div class="checkout-item-text">
            <h1>1 {{selectedBox.formattedName}}</h1>
          </div>
          <div class="checkout-price">
            <p>${{selectedBox.formattedPriceUSD}}</p>
            <div class="divider"></div>
            <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{selectedBox.formattedPriceKMON}}</p>
          </div>
        </div>
        <div class="checkout-item unfreeze" *ngIf="unfreezeSelected">
          <img src="{{unfreeze.img}}" class="uf" />
          <div class="checkout-item-text">
            <h1>1 {{unfreeze.formattedName}}</h1>
          </div>
          <div class="checkout-price">
            <p>${{unfreeze.formattedPriceUSD}}</p>
            <div class="divider"></div>
            <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{unfreeze.formattedPriceKMON}}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
  <div class="col-lg-6 w-full md:w-1/2 col card box-container">
    <!-- <div class="card box-container"> -->
    <div class="boxes-container">
      <div class="boxes-list" *ngIf="parsedBoxes">
        <div class="boxes-item" *ngFor="let pb of lootBoxes; let i = index"
          [ngClass]="{'selected':boxSelected[i], 'green-free': i == 0}" (click)="selectBox(i)">
          <img src="{{pb.img}}" />
          <div class="box-detail">
            <h1>{{pb.formattedName}}</h1>
            <p>{{pb.description}}</p>
          </div>
          <div class="price-item" *ngIf="i > 0">
            <p class="usd-value">${{pb.formattedPriceUSD}}</p>
            <div class="divider"></div>
            <p class="kmon-bnb">
              <img src="./assets/img/Home/k-logo.png" />
              {{pb.formattedPriceKMON}}
            </p>
          </div>
          <div class="price-item" *ngIf="i == 0">
            <p class="usd-value uppercase">{{t('onboarding.freeIncluded')}}</p>
          </div>
        </div>
        <div class="boxes-item" (click)="selectUnfreeze()" [ngClass]="{'selected':unfreezeSelected}">
          <img src="{{unfreeze.img}}" class="unfreeze" />
          <div class="box-detail">
            <h1>{{unfreeze.formattedName}}</h1>
            <p>{{unfreeze.description}}</p>
          </div>
          <div class="price-item">
            <p class="usd-value">${{unfreeze.formattedPriceUSD}}</p>
            <div class="divider"></div>
            <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{unfreeze.formattedPriceKMON}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons" *ngIf="parsedBoxes">
      <div class="button-outline" (click)="goBack()">{{t('shared.back')}}</div>
      <div class="button-gradient" (click)="confirmBox()">{{t('shared.next')}}</div>
      <!--<div class="button-outline" *ngIf="isLoading">
          <fa-icon [icon]="['fas', 'spinner']" class="fa-spin"></fa-icon>
        </div>-->
    </div>
    <!-- </div> -->
  </div>